import { useSelector } from 'react-redux';
import { selectMachines } from '@reducers/machines';
import { useTrackScreenOpened, TRACKING_EVENTS } from '@services/tracking';
import { Machine } from '@interfaces/machines';

export const useTrackWallboardOpened = () => {
  const machines = useSelector(selectMachines) as Machine[];

  useTrackScreenOpened(TRACKING_EVENTS.WALLBOARD, () => ({
    machineCount: machines?.length || 0,
    viewMode: 'live',
  }));
};
